import { reducer as favouritesReducer } from '@noths/polaris-client-user-favourites';
import { combineReducers } from '@reduxjs/toolkit';
import { routerReducer } from 'connected-next-router';

import { reducer as accessibilityReducer } from 'src/redux/accessibility/slice';
import { reducer as contentReducer } from 'src/redux/content/slice';
import { reducer as navigationReducer } from 'src/redux/navigation/slice';
import { reducer as partnerInsightsReducer } from 'src/redux/partnerInsights/slice';
import { reducer as productReducer } from 'src/redux/products/slice';
import { reducer as filterReducer } from 'src/redux/productsQuery/slice';
import { reducer as userReducer } from 'src/redux/user/slice';
import { reducer as visibilityTrackingReducer } from 'src/redux/visibilityTracking/slice';

export const combinedReducer = combineReducers({
  accessibility: accessibilityReducer,
  content: contentReducer,
  favourites: favouritesReducer,
  navigation: navigationReducer,
  partnerInsights: partnerInsightsReducer,
  products: productReducer,
  productsQuery: filterReducer,
  router: routerReducer,
  user: userReducer,
  visibilityTracking: visibilityTrackingReducer,
});

export type ReduxApplicationState = ReturnType<typeof combinedReducer>;
